// La tarjeta del cliente, derivada del bloque `card` del resumen 360. La ficha solo distingue la
// tarjeta emitida de la que no lo está: sin emisión no hay dígitos ni fecha que describir.
import type { Customer360Card } from '@/api/services/retail-customer/retail-customer.client';

/** Qué se sabe de la tarjeta. `none` cubre el bloque ausente y el `issued: false`. */
export type CardRead =
    | { state: 'none' }
    | {
          state: 'issued';
          panLastDigit: string | null;
          issuedAt: string | null;
      };

/** El bloque de la tarjeta leído. Con `issued: false` los demás campos no describen nada. */
export function cardReadOf(card: Customer360Card | undefined): CardRead {
    if (!card?.issued) return { state: 'none' };
    return {
        state: 'issued',
        panLastDigit: card.panLastDigit,
        issuedAt: card.issuedAt ?? null,
    };
}
